import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as XLSX from 'xlsx'

import { fetchCustomers, fetchSAPValues } from '../actions/customers'
import { fetchSLAs } from '../actions/slas'

import CustomerCardList from '../components/CustomerCardList'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import "../styles/CustomersAdminView.css"

class CustomersView extends React.Component {
  constructor(props) {
    super(props)

    this.handleDownloadSAPValuesCSV = this.handleDownloadSAPValuesCSV.bind(this);
    this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
  }

  componentDidMount() {
    this.props.fetchCustomers()
    this.props.fetchSLAs()
  }

  handleDownloadSAPValuesCSV() {
    const { fetchSAPValues } = this.props

    fetchSAPValues();
  }

  handleDownloadExcel() {
    const { customers } = this.props

    const licenseLabel = (type) => {
      if (type === 'LICENCIA_PRO') return 'Pro'
      if (type === 'GROUP') return 'Group'
      if (type === 'LICENCIA_BASICA' || type === 'GENERAL') return 'Básica'
      return type || '-'
    }

    const data = customers
      .filter(c => c.Type === 'GENERAL' || c.Type === 'LICENCIA_BASICA' || c.Type === 'LICENCIA_PRO' || c.Type === 'GROUP')
      .map(c => ({
        Nombre: c.Fullname || '-',
        Email: c.Email || '-',
        'Tipo de Licencia': licenseLabel(c.Type),
      }))

    const worksheet = XLSX.utils.json_to_sheet(data)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Clientes')
    XLSX.writeFile(workbook, 'clientes.xlsx')
  }

  render() {
    const { role, type, customers, loading, error } = this.props

    if (error) {
      return (
        <ErrorMessage message={error.message} />
      )
    }

    if (!customers || loading) {
      return <LoadingProgress />
    }

    return (
      <div className="customers-admin-view">
        <div className="customers-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-user mr-3"></i>
                <span className="text-vw-dark mr-1">CLIENTES</span>
              </h1>
            </div>
            <div className="header-actions">
              {role === 'ADMIN' && (
                <>
                  <Link to="/customers/add" className="customers-admin-btn primary">
                    <i className="fas fa-plus"></i>
                    <span>Nuevo Cliente</span>
                  </Link>

                  <Link to="/customersgroup/add" className="customers-admin-btn secondary">
                    <i className="fas fa-users"></i>
                    <span>Nuevo Grupo</span>
                  </Link>

                  <button className="customers-admin-btn warning" onClick={this.handleDownloadSAPValuesCSV}>
                    <i className="fas fa-file-excel"></i>
                    <span>Descargar SAP</span>
                  </button>

                  <button className="customers-admin-btn success" onClick={this.handleDownloadExcel}>
                    <i className="fas fa-file-download"></i>
                    <span>Exportar Excel</span>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <CustomerCardList customers={customers} slas={this.props.slas} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customers: state.customers.customers,
  error: state.customers.error,
  loading: state.customers.loading,
  role: state.auth.role,
  type: state.auth.type,
  slas: state.slas.slas,
})

const mapDispatchToProps = dispatch => ({
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  fetchSAPValues: bindActionCreators(fetchSAPValues, dispatch),
  fetchSLAs: bindActionCreators(fetchSLAs, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomersView)

